import { Link } from "react-router-dom";

const categoryLinks = [
  { to: "/category/movie", label: "电影频道" },
  { to: "/category/tv", label: "电视剧频道" },
  { to: "/category/variety", label: "综艺频道" },
  { to: "/category/documentary", label: "纪录片频道" },
];

const siteLinks = [
  { to: "/", label: "首页" },
  { to: "/special", label: "影视专题" },
  { to: "/search", label: "搜索影视" },
  { to: "/about", label: "关于我们" },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-200">
      <div className="px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-tv-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black text-background-50">
                棒棒<span className="text-accent-500">TV</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              棒棒TV 专注于影视剧资讯与精选推荐，涵盖电影、电视剧、综艺与纪录片，帮你更快找到想看的好作品。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-200" aria-label="微信公众号">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-200" aria-label="官方微博">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-800 text-background-200" aria-label="视频号">
                <i className="ri-video-line"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">影视频道</h3>
            <ul className="mt-4 space-y-3">
              {categoryLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-500"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-3">
              {siteLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-300 transition-colors hover:text-accent-500"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 棒棒TV · 本站影视信息与剧情均为虚构演示内容，仅供资讯与推荐展示。</p>
          <p className="flex flex-wrap gap-x-4 gap-y-2">
            <span className="cursor-pointer transition-colors hover:text-accent-500">友情链接：影视观察</span>
            <span className="cursor-pointer transition-colors hover:text-accent-500">光影笔记</span>
            <span className="cursor-pointer transition-colors hover:text-accent-500">剧集研究所</span>
          </p>
        </div>
      </div>
    </footer>
  );
}